import ".././styles/Rental.css";
import boardroompic from ".././assets/boardroom.jpg";
import { Link } from "react-router-dom";

function Boardroom() {
    return (
        <div className="container">
            <div className="rental-section">
                


                <div className="rental-details">
                    <div className="rental-image-container">
                        <img className="rental-image" src={boardroompic} alt="Image of the banquet hall."></img>
                    </div>
                    <div className="rental-description">
                        <h2 className="rental-title">Boardroom</h2>
                        <p>
                            The Boardroom is a private meeting space available for rent, ideal for small group meetings, presentations, or workshops. 
                            It includes a microwave, kettle, coffee maker, and coat rack for convenience. 
                            <br></br><br></br>
                            If you want to inquire about the Boardroom, please contact us at <i>(204) 775-4928</i>. If you want to book the Boardroom, 
                            please contact us at <i>president@thenewpccm.ca</i>. Alternatively, you can connect with us on our <a href="/contact" className="redirect-page">Contact Us Page</a>.
                        </p>
                        {/* <Link className="rental-agreement-btn">View Rental Agreement &#62;</Link> */}
                    </div>
                </div>

                <div className="rental-features-details">
                    {/* <div className="rental-features-details-child">
                        <h3>Features</h3>
                        <ul>
                            <li><p>Call for more details</p></li>
                        </ul>
                    </div> */}
                    <div className="rental-features-details-child" id="rates-section">
                        <h3>Rates</h3>
                        <ul>
                            <li><p><span className="left">Daily:</span><span className="right"> $25 per hour</span></p></li>
                        </ul>

                        {/* <h3 className="socan">SOCAN Fee</h3>
                        <ul>
                            <li><p><span className="left">1-100 Guests:</span><span className="right"> $22.75</span></p></li>
                            <li><p><span className="left">101-200 Guests:</span><span className="right"> $34.15</span></p></li>
                            <li><p><span className="left">over 200 Guests:</span><span className="right"> $51.20</span></p></li>
                        </ul> */}
                    </div>
                    <div className="rental-features-details-child" id="additionals-section">
                        {/* <h3>Additional</h3>
                        <ul>
                            <li><p><span className="left">Damage Deposit:</span><span className="right"> $300</span></p></li>
                            <li><p><span className="left">Set-up/Cleaning (6AM - 6PM):</span><span className="right"> $150</span></p></li>
                            <li><p><span className="left">Set-up/Cleaning (6PM - 1AM):</span><span className="right"> $200</span></p></li>
                            <li><p><span className="left">Bartenders (2):</span><span className="right"> $136 for 4 hours</span></p></li>
                            <li><p><span className="left">Security Guards (2):</span><span className="right"> $160 for 4 hours</span></p></li>
                        </ul> */}
                    </div>
                </div>
                {/* <button className="button-1" id="book-button"><h4>Book</h4></button> */}
            </div>
        </div>
    );
}

export default Boardroom;